import { mapActions } from 'vuex'
import { ErrorHelper } from '@/helpers/ErrorHelper'
import { AlternateContactCacheMixin } from './AlternateContactCacheMixin'

export const AlternateContactAddMixin = {
  mixins: [AlternateContactCacheMixin],
  data () {
    return {
      name: '',
      mobile: '',
      email: '',
      otherInfo: ''
    }
  },
  computed: {
    alternateContactAddModel () {
      return Object.assign({}, {
        contactTypeId: this.contactTypeId,
        name: this.name,
        mobile: this.mobile,
        email: this.email,
        otherInfo: this.otherInfo
      })
    }
  },
  methods: {
    ...mapActions('RegistrationAlternateContact', [
      'addAlternateContact'
    ]),
    tryAddAlternateContact () {
      const self = this
      if (self.loadingAlternateContact) {
        return
      }
      self.error = ''
      return self.addAlternateContact({ inviteId: self.inviteId, payload: self.alternateContactAddModel })
        .then(response => { self.afterAddAlternateContact(response.data) })
        .catch(error => {
          if (ErrorHelper.isNotFound(error)) {
            self.afterAddAlternateContact()
          } else {
            self.error = ErrorHelper.getError(error)
          }
        })
    },
    afterAddAlternateContact () {
      // override if necessary
    }
  }
}
